import React from 'react';
import { NavLink as RouterLink } from 'react-router-dom';

import styled from '@emotion/styled';

export const NavLink = styled(RouterLink)`
  text-decoration: none;
  color: black;
  font-weight: 500;
  display: flex;
  gap: 0.5rem;

  &.footer {
    font-weight: 600;
  }

  &.hamburger-menu {
    font-size: 1rem;
    font-weight: 600;
    color: black;
  }
`;

interface IExternalLink {
  children: React.ReactNode;
  to: string;
  className?: string;
}

export const ExternalLink: React.FC<IExternalLink> = ({
  children,
  to,
  className,
}) => {
  return (
    <AnchorTag
      href={to}
      target='_blank'
      rel='noopener noreferrer'
      className={className}
    >
      {children}
    </AnchorTag>
  );
};

export const AnchorTag = styled.a`
  text-decoration: none;
  font-weight: 500;

  &.footer {
    display: grid;
    grid-template-columns: 1.5rem auto;
    gap: 0.5rem;
    font-weight: 600;
  }

  &.color_red{
    color: ${({ theme }) => theme.palette.redFontColor};
  }

  &.header_nav__mobile {
    @media (max-width: 884px) {
      display: None;
    }
  }
`;

export const ButtonLink = styled(RouterLink)`
  text-decoration: none;
  font-weight: 500;
`;

interface INavItem {
  icon: React.ReactNode;
  children: string;
  path: string;
}

export const NavBoxItem: React.FC<INavItem> = ({ icon, path, children }) => {
  return (
    <NavigationBoxLink
      className={(navData) => (navData.isActive ? 'active' : '')}
      to={path}
    >
      {icon}
      {children}
    </NavigationBoxLink>
  );
};

export const NavigationBoxLink = styled(RouterLink)`
  text-decoration: none;
  color: ${({ theme }) => theme.palette.primaryButtonColor};
  display: flex;
  gap: 1.25rem;

  padding: 0.81rem 1.31rem;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-weight: 400;
  display: flex;
  align-items: center;

  &:hover {
    /* background-color: #d2dfff28; */
    color: ${({ theme }) => theme.palette.primaryButtonColor};
  }

  &.active {
    background-color: #2858d128;
    color: ${({ theme }) => theme.palette.primaryButtonColor};
  }
`;

export const InternalNavLink = styled(RouterLink)`
  text-decoration: none;
  color: ${({ theme }) => theme.palette.navLinkcolor};
  font-weight: 600;

  /* &:hover {
    color: #000000a7 !important;
  } */

  &.active {
    color: ${({ theme }) => theme.palette.redFontColor};
  }

  &.dropDown {
    color: #41415a;
    font-weight: 500;
    font-size: 14px;
  }

  &.footer {
    color: rgba(255, 255, 255, 0.8);
    font-size: 0.875rem;
    font-weight: 400;
  }

  &.footer:hover {
    color: rgba(255, 255, 255);
  }

  &.hamburger {
    color: ${({ theme }) => theme.palette.navLinkcolor};
    font-size: 1rem;
    font-weight: 600;
  }
`;
